export const HeadNav = () => {
    const logout = () => {
        localStorage.clear()
       

        window.location.replace('/');

    }
    return <>
            <div className="row head_nav">
                <div className="col-12">
                    <div className="nav_head">              
                        <h1 className="head">HARVESTMART Alimentation</h1>
                        <div className="logout_container">
                            {
                                localStorage.getItem("token")?
                                <button onClick={()=> logout()}>Log out</button>:<></>
                            }
                        </div>
                    </div>          
                </div>
            </div>
    </>
}